import {
  Calendar,
  ChevronRight,
  Clock,
  MapPin,
  Type,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { ProposalChange, ProposalField } from '@/lib/reviewProposal';

const CHANGE_ICON: Record<ProposalField, LucideIcon> = {
  title: Type,
  date: Calendar,
  time: Clock,
  endTime: Clock,
  location: MapPin,
  children: Users,
};

export interface ChangeLineProps {
  change: ProposalChange;
}

/**
 * One changed field: the old value struck through, a chevron, the new value
 * bold. Shared by the review card and the details sheet's Change box.
 */
export function ChangeLine({ change }: ChangeLineProps) {
  const Icon = CHANGE_ICON[change.field];
  return (
    <div className="flex items-start gap-1.5 text-sm">
      <Icon
        size={16}
        strokeWidth={1.5}
        aria-hidden="true"
        className="mt-0.5 shrink-0 text-muted-foreground"
      />
      <div className="flex min-w-0 flex-col">
        {change.before !== null && (
          <span className="flex items-center gap-1">
            <span className="min-w-0 break-words line-through text-text-caption">
              {change.before}
            </span>
            <ChevronRight
              size={16}
              strokeWidth={1.5}
              aria-hidden="true"
              className="shrink-0 text-icon-default"
            />
          </span>
        )}
        <span className="min-w-0 break-words font-semibold text-foreground">
          {change.after}
        </span>
      </div>
    </div>
  );
}
